import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import Error from "./Error";

// Import testing utilities for browser console access
import { 
  isPointInPolygon, 
  isWithinGenevaCanton, 
  GenevaTestUtils, 
  extractBoundarySegments, 
  connectBoundarySegments, 
  parseKMLCoordinates 
} from './utils/genevaPolygon';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: (
      <Error
        status="404"
        title="La page demandée n'existe pas."
        action={{
          on: () => (window.location.href = "/collections"),
          title: "Vers la page d'acceuil",
        }}
      />
    ),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#001482",
          colorBgBase: "#ffffff",
          colorBgContainer: "#ffffff",
          colorLink: "#001482",
          colorLinkActive: "#001482",
          fontFamily: '"Questrial", sans-serif',
          fontFamilyCode: '"Montserrat", sans-serif',
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  </React.StrictMode>
);

// Make testing utilities available in browser console (development only)
if (process.env.NODE_ENV === 'development') {
  (window as any).genevaUtils = {
    isPointInPolygon,
    isWithinGenevaCanton,
    extractBoundarySegments,
    connectBoundarySegments,
    parseKMLCoordinates,
    ...GenevaTestUtils
  };
  
  console.log('🔧 Geneva testing utilities loaded! Available at window.genevaUtils');
  console.log('Try: genevaUtils.testSimplePolygon() or genevaUtils.testGenevaCoordinates()');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
